import './PageFraming.scss';
import { FC } from "react";

export const Footer: FC = () => {
	return (
		<div className="footer-container-flex-wrapper">
			<div className="footer-container">
				<p className="powered-by-header">Powered by</p>
				<div className="footer-box-wrapper">
					<div className="footer-icon">
						<img loading="lazy" src="https://sites.spondo.com/wp-content/uploads/2020/07/spondo.png"
							 alt="Spondo Logo" width="284" height="178" />
						<a href="https://www.spondo.com" target="_blank" rel="noreferrer">www.spondo.com</a>
					</div>
					<div className="footer-testimonial">
						<p>“The team at Spondo has helped us deliver a digital film festival to our valued audience in a seamless fashion.”</p>
						<p><span className="testimonial-author">Steve Pereira<br/>Sunshine Short Film Festival</span></p>
					</div>
					<div className="footer-icon">
						<img loading="lazy" src="https://sites.spondo.com/wp-content/uploads/2021/01/SSFF-Wide-logo-for-footer.jpg"
							 alt="SSFF Logo" width="284" height="178" />
						<a href="https://sunshinefilmfestival.com.au" target="_blank" rel="noreferrer">sunshinefilmfestival.com.au</a>
					</div>
				</div>
			</div>
		</div>
	);
}
